import { NicknameForm } from '@/features/Nickname/components/NicknameForm';

export const Nickname = () => <NicknameForm />;
